import axios from "axios";
import { apiServicesUrl } from "./baseUrl";
import { userAccessToken } from "../helpers";

export const fetchWaitingRoom = (filter) => {
  const {
    page,
    per_page,
    search_term,
    start_date,
    end_date,
    account_id,
    location_id,
    speciality_id,
    order_by,
    provider_id
  } = filter;

  let providerId = provider_id ? `&provider_id=${provider_id}` : "";
  let specialityId = speciality_id ? `&speciality_id=${speciality_id}` : "";
  let searchParam = search_term ? `&search_term=${search_term}` : "";
  let startDateParam = start_date ? `&start_date=${start_date}` : "";
  let endDateParam = end_date ? `&end_date=${end_date}` : "";
  let orderBy = order_by ? `&order_by=${JSON.stringify(order_by)}` : "";

  return axios.get(
    `${apiServicesUrl}/waiting_rooms?account_id=${account_id}&location_id=${location_id}${specialityId}&page=${page}&per_page=${per_page}${searchParam}${startDateParam}${endDateParam}${orderBy}${providerId}`,
    {
      headers: {
        "Content-Type": "application/json",
        accept: "application/json",
        Authorization: `Bearer ${userAccessToken()}`,
      },
    }
  );
};

export const deleteWaitingRoomData = (id, account_id, location_id) => {
  return axios.delete(
    `${apiServicesUrl}/waiting_room/delete/${id}?account_id=${account_id}&location_id=${location_id}`,
    {
      headers: {
        "Content-Type": "application/json",
        accept: "application/json",
        Authorization: `Bearer ${userAccessToken()}`,
      },
    }
  );
};

export const updateSignOutSheet = async (
  account_id,
  location_id,
  id,
  is_print
) => {
  try {

    let data = {
      account_id: account_id,
      location_id: location_id,
      id: id,
      is_print: is_print
    };
    return axios.put(
      `${apiServicesUrl}/waiting_room/print-update`,
      data,
      {
        headers: {
          "Content-Type": "application/json",
          accept: "application/json",
          Authorization: `Bearer ${userAccessToken()}`,
        },
      }
    );


  } catch (error) {}
};

export const saveTranscriptionText = async (
  account_id,
  location_id,
  id,
  voice_transcribe,
  question_list,
  diagnosis_list,
  record_times
) => {
  try {

    let data = {
      account_id: account_id,
      location_id: location_id,
      id: id,
      voice_transcribe: voice_transcribe,
      question_list: question_list,
      diagnosis_list: diagnosis_list,
      record_times: record_times
    };
    return axios.put(
      `${apiServicesUrl}/waiting_room/transcribe-update`,
      data,
      {
        headers: {
          "Content-Type": "application/json",
          accept: "application/json",
          Authorization: `Bearer ${userAccessToken()}`,
        },
      }
    );


  } catch (error) {}
};

export const updatePostVisitNote = (data) => {
  try {
    const response = axios.put(`${apiServicesUrl}/waiting_room/previsit-update`, data,
      {
        headers: {
          "Content-Type": "application/json",
          accept: "application/json",
          Authorization: `Bearer ${userAccessToken()}`,
        },
      }
    );
    return response;

  } catch (error) {
    return error?.response?.data;
  }
};

export const copyAllPrevisitCodes = (filter, id) => {
  const {
    account_id,
    location_id,
    speciality_id,
    provider_id,
    start_date,
    end_date
  } = filter;

  let specialityId = speciality_id ? `&speciality_id=${speciality_id}` : "";
  let providerId = provider_id ? `&provider_id=${provider_id}` : "";
  let startDateParam = start_date ? `&start_date=${start_date}` : "";
  let endDateParam = end_date ? `&end_date=${end_date}` : "";
  let waitingId = id ? `&waiting_room_id=${id}` : "";

  try {
    const response = axios.get(
      `${apiServicesUrl}/waiting_room/get-suggested-codes?account_id=${account_id}&location_id=${location_id}${specialityId}${providerId}${startDateParam}${endDateParam}${waitingId}`,
      {
        headers: {
          "Content-Type": "application/json",
          accept: "application/json",
          Authorization: `Bearer ${userAccessToken()}`,
        },
      }
    );
    return response;

  } catch (error) {
    return error?.response?.data;
  }
};

export const deleteBulkWaitingData = async (deleteData) => {
  try {
    const response = await axios.delete(`${apiServicesUrl}/waiting_room/bulk-delete`, {
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: `Bearer ${userAccessToken()}`,
      },
      data: deleteData,
    });
    return response;
  } catch (error) {
    return error?.response?.data;
  }
};

export const uploadChartToEHR = async (data) => {
  try {
    const response = await axios.post(
      `${apiServicesUrl}/ehr/push_to_unity_ehr`, data,
      {
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: `Bearer ${userAccessToken()}`,
        },
      }
    );
    return response;
  } catch (error) {
    return error?.response?.data;
  }
};

export const fetchNewVeradigmData = async (data) => {
  try {
    const response = await axios.post(`${apiServicesUrl}/ehr/sync-unity-appointment`,
      data,
      {
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: `Bearer ${userAccessToken()}`,
        },
      }
    );
    return response;
  } catch (error) {
    return error?.response?.data;
  }
};

export const exportAllWaitingRoom = async (filter) => {
  const {
    page,
    per_page,
    search_term,
    start_date,
    end_date,
    account_id,
    location_id,
    speciality_id,
    order_by,
    provider_id
  } = filter;

  try {
    let providerId = provider_id ? `&provider_id=${provider_id}` : "";
    let specialityId = speciality_id ? `&speciality_id=${speciality_id}` : "";
    let searchParam = search_term ? `&search_term=${search_term}` : "";
    let startDateParam = start_date ? `&start_date=${start_date}` : "";
    let endDateParam = end_date ? `&end_date=${end_date}` : "";
    let orderBy = order_by ? `&order_by=${JSON.stringify(order_by)}` : "";

    return axios.get(`${apiServicesUrl}/waiting_rooms/previsit_export_excel?account_id=${account_id}&location_id=${location_id}${specialityId}&page=${page}&per_page=${per_page}${searchParam}${startDateParam}${endDateParam}${orderBy}${providerId}`,
      {
        headers: {
          "Content-Type": "application/json",
          accept: "application/json",
          Authorization: `Bearer ${userAccessToken()}`,
        },
      }
    );
  } catch (error) {}
};

export const checkBulkEligibilityData = async (data) => {
  try {
    const response = await axios.post(`${apiServicesUrl}/waiting-room/bulk-eligibility-check`, data, {
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: `Bearer ${userAccessToken()}`,
      },
    });
    return response;
  } catch (error) {
    return error?.response?.data;
  }
};

export const checkBulkClaimsData = async (data) => {
  try {
    const response = await axios.post(`${apiServicesUrl}/waiting-room/bulk-claim-status-check`, data, {
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: `Bearer ${userAccessToken()}`,
      },
    });
    return response;
  } catch (error) {
    return error?.response?.data;
  }
};

export const createBulkWaingList = async (data) => {
  try {
    const response = await axios.post(`${apiServicesUrl}/waiting_room_bulk_create`, data, {
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: `Bearer ${userAccessToken()}`,
      },
    });
    return response;
  } catch (error) {
    return error?.response?.data;
  }
};
